import React from 'react'
import PropTypes from 'prop-types';

import Icon from './icons/icon';
import * as models from './icons';

class Svg extends React.Component {
    static propTypes = {
        onClick: PropTypes.func,
        className: PropTypes.string,
        name: PropTypes.string,
        models: PropTypes.array,
    }

    static defaultProps = {
        models: [],
        name: 'defaultIcon'
    }

    models = this.props.models.concat(models)



    render() {
        let { name, className=false, onClick} = this.props;

        this.models[name] && (name = this.models[name])
        this.props.models[name] && (name = this.props.models[name])

        className = 'svg' + (className ? ' ' + className : '')

        return <Icon className={className} svg={name} onClick={onClick} />
    }
}

export default Svg
